import { render, staticRenderFns } from "./integration-numbers.vue?vue&type=template&id=42cc85a7&"
import script from "./integration-numbers.vue?vue&type=script&lang=js&"
export * from "./integration-numbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports